import { clsx, ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function isSuccessReq(statusCode: number): boolean {
  return statusCode >= 200 && statusCode < 300
}
